declare global {
  interface Window {
    ChurnZero: string[][] | undefined
  }
}

export const setChurnZeroContact = ({
  id,
  email,
}: {
  id: string
  email: string
}) => {
  if (!window.ChurnZero) {
    console.error('The ChurnZero script could not be found.')
    return
  }

  window.ChurnZero.push(['setContact', id, email])
}
